const comparisonData = [
  { feature: "Ease of Use", itaobuy: "Excellent", taobao: "Difficult", aliexpress: "Moderate", agents: "Difficult" },
  { feature: "Product Structure", itaobuy: "Spreadsheet Format", taobao: "Search-Based", aliexpress: "Search-Based", agents: "Manual" },
  { feature: "Beginner Friendly", itaobuy: "Yes", taobao: "No", aliexpress: "Medium", agents: "No" },
  { feature: "Price Transparency", itaobuy: "High", taobao: "Medium", aliexpress: "Medium", agents: "Low" },
  { feature: "Shipping Guidance", itaobuy: "Included", taobao: "None", aliexpress: "Partial", agents: "Manual" },
  { feature: "Safety Level", itaobuy: "High", taobao: "Medium", aliexpress: "Medium", agents: "Low" },
];

function RatingBadge({ value }: { value: string }) {
  const isPositive = value === "Excellent" || value === "High" || value === "Yes" || value === "Included" || value === "Spreadsheet Format";
  const isMedium = value === "Moderate" || value === "Medium" || value === "Partial" || value === "Search-Based";
  const isNegative = value === "Difficult" || value === "No" || value === "Low" || value === "None" || value === "Manual";

  return (
    <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
      isPositive ? "bg-accent-100 text-accent-800" :
      isMedium ? "bg-secondary-100 text-secondary-700" :
      isNegative ? "bg-background-200 text-foreground-500" :
      ""
    }`}>
      {value}
    </span>
  );
}

export default function ComparisonTable() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">Comparison</p>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
            Itaobuy Spreadsheet vs Other China Shopping Methods
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            See how the itaobuyspreadsheet system compares against direct marketplace browsing. Structured data beats endless scrolling every time.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 text-foreground-700 font-medium whitespace-nowrap">Feature</th>
                <th className="text-left px-5 py-4 text-primary-700 font-semibold whitespace-nowrap">Itaobuy Spreadsheet</th>
                <th className="text-left px-5 py-4 text-foreground-500 font-medium whitespace-nowrap">Taobao Direct</th>
                <th className="text-left px-5 py-4 text-foreground-500 font-medium whitespace-nowrap">AliExpress</th>
                <th className="text-left px-5 py-4 text-foreground-500 font-medium whitespace-nowrap">1688 Agents</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}>
                  <td className="px-5 py-3.5 text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                  <td className="px-5 py-3.5"><RatingBadge value={row.itaobuy} /></td>
                  <td className="px-5 py-3.5"><RatingBadge value={row.taobao} /></td>
                  <td className="px-5 py-3.5"><RatingBadge value={row.aliexpress} /></td>
                  <td className="px-5 py-3.5"><RatingBadge value={row.agents} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}